import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { ConfigService } from '../../../config/config-service';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionService } from '../../../services/session.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
	selector: 'reporte-modal',
	templateUrl: './reporte-modal.component.html',
	styleUrls: ['./reporte-modal.component.css'],
})
export class ReporteModalComponent implements OnInit {
    //@Input() code: String;
    ///@Input() params: Array<String>;
    @Input() route: String;
    @Input() qs: String;
    @Input() host_api: String = "";

    public config: ConfigService;

	constructor(
        private sanitizer: DomSanitizer,
        private ss: SessionService,
        public bsModalRef: BsModalRef,
    ) {
		this.config = new ConfigService();
	}

	ngOnInit() {
		//
    }
    
    endPoint(){
        let endpoint;
        if( this.host_api.toString().trim().length > 1 ){
            endpoint = this.host_api.toString() + this.route.toString() + this.qs;
        }else{
            endpoint = this.ss.getData('host_api') + "/pdf/" + this.route + this.qs + "&tk=" + this.ss.getData('api-token');
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(endpoint);
        
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/reporte-modal/reporte-modal.component.ts